import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Switch,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { Formik, FormikHelpers } from 'formik';
import {
  AppFormikTextField,
  AppPrimaryButton,
  AppPrimaryButtonOutlined,
} from 'shared/components/AppComponents';
import { ReactElement } from 'react';
import { toolGovernanceSchema } from 'validators/GuardTrailSchema';

interface CreateToolFormValues {
  toolName: string;
  isRequried: boolean;
}

interface CreateToolDialogProps {
  open: boolean;
  onCloseCreateTool: () => void;
  onSubmitTool: (
    values: CreateToolFormValues,
    formikHelpers: FormikHelpers<CreateToolFormValues>
  ) => void;
}

const CreateToolDialog = ({
  open,
  onCloseCreateTool,
  onSubmitTool,
}: CreateToolDialogProps): ReactElement => {
  const actionOnSubmit = (
    formValues: any,
    formikHelper: FormikHelpers<any>
  ): void => {
    onSubmitTool(formValues, formikHelper);
  };

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => {
          onCloseCreateTool();
        }}
      >
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box>
              <Typography variant="h3">Register Server</Typography>
            </Box>
            <IconButton
              onClick={() => {
                onCloseCreateTool();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>
        <Formik
          initialValues={{ toolName: '', isRequried: false }}
          validationSchema={toolGovernanceSchema}
          enableReinitialize
          validateOnMount
          onSubmit={(formValues, formik) => {
            actionOnSubmit(formValues, formik);
          }}
        >
          {({ handleSubmit, isSubmitting, isValid, values, setFieldValue }) => (
            <>
              <DialogContent>
                <AppFormikTextField
                  name="toolName"
                  outerLabel
                  label="Tool Name"
                  placeholder="My MCP Server"
                />

                <Box className="align-center ">
                  <Switch
                    checked={values.isRequried}
                    onChange={(e) => {
                      const newValue = e.target.checked;
                      setFieldValue('isRequried', newValue);
                    }}
                    color="primary"
                  />
                  <Typography variant="body1">
                    Requires human approval (step-up)
                  </Typography>
                </Box>
              </DialogContent>
              <DialogActions>
                <Stack
                  className="mx-4 mb-4"
                  direction="row"
                  spacing={2}
                  alignItems="center"
                >
                  <AppPrimaryButtonOutlined
                    title="Cancel"
                    className="btn-small"
                    onClick={() => {
                      onCloseCreateTool();
                    }}
                  />
                  <AppPrimaryButton
                    isLoading={isSubmitting}
                    onClick={handleSubmit}
                    disabled={!isValid || isSubmitting}
                    loadingText="Saving"
                    title="Add Tool"
                    className="btn-small"
                  />
                </Stack>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
};

export default CreateToolDialog;
